import { render } from "./About.vue?vue&type=template&id=c9d6945e&bindings={}"
import script from "./About.vue?vue&type=script&lang=js"
export * from "./About.vue?vue&type=script&lang=js"
script.render = render

export default script